// export function flattenObject(obj: Record<string, any>, parentKey = '') {
//   let result: Record<string, any> = {}

//   for (const key in obj) {
//     if (Object.prototype.hasOwnProperty.call(obj, key)) {
//       const newKey = parentKey ? `${parentKey}.${key}` : key

//       if (typeof obj[key] === 'object' && obj[key] !== null && !Array.isArray(obj[key])) {
//         // If the value is a non-null, non-array object, recursively flatten it
//         const nestedFlat = flattenObject(obj[key], newKey)
//         result = {...result, ...nestedFlat} // Merge the flattened nested object
//       } else {
//         // Otherwise, add the key-value pair to the result
//         result[newKey] = obj[key]
//       }
//     }
//   }
//   return result
// }

export function flattenObject(
  obj: Record<string, any>,
  prefix = '',
  result: Record<string, any> = {}
) {
  if (Array.isArray(obj)) {
    obj.forEach((item, index) => {
      flattenObject(item, `${prefix}[${index}]`, result)
    })
  } else if (typeof obj === 'object' && obj !== null) {
    for (let key in obj) {
      flattenObject(obj[key], prefix ? `${prefix}.${key}` : key, result)
    }
  } else {
    result[prefix] = obj
  }
  return result
}
export function getValues(obj: any) {
  const result: string[] = []

  function recurse(value: any) {
    if (value && typeof value === 'object') {
      for (const key in value) {
        recurse(value[key])
      }
    } else {
      result.push(String(value))
    }
  }

  recurse(obj)
  return result
}
